"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _ProductDetailContext = _interopRequireDefault(require("../context/ProductDetailContext"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useAddToCartDisabled = _ref => {
  let {
    displayedAttributes
  } = _ref;
  const {
    attributes
  } = (0, _react.useContext)(_ProductDetailContext.default);
  const [disabled, setDisabled] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if ((0, _isEmpty.default)(attributes)) return;
    for (const key in attributes) {
      const attribute = attributes === null || attributes === void 0 ? void 0 : attributes[key];
      if (displayedAttributes.indexOf(key) === -1) continue;
      if (attribute) {
        var _attribute$items;
        const isSelected = attribute === null || attribute === void 0 || (_attribute$items = attribute.items) === null || _attribute$items === void 0 ? void 0 : _attribute$items.some(_ref2 => {
          let {
            selected
          } = _ref2;
          return selected;
        });
        if (!isSelected) {
          setDisabled(true);
        }
      }
    }
    return () => {
      setDisabled(false);
    };
  }, [attributes, displayedAttributes]);
  return disabled;
};
var _default = exports.default = useAddToCartDisabled;